export default "__VITE_ASSET__CGf6lLFo__"